export const POSTMAN_DOWNLOAD_LINK = 'https://www.postman.com/downloads/';

export const POSTMAN_BRANDS_COLLECTION_PATH = '/Buy Now Brands.postman_collection.json';
export const POSTMAN_VENDORS_COLLECTION_PATH = '/Buy Now Vendors.postman_collection.json';

export const POSTMAN_BRANDS_ENV_PATH = '/Buy Now ENV - Brands.postman_environment.json';
export const POSTMAN_VENDORS_ENV_PATH = '/Buy Now ENV - Vendors.postman_environment.json';

export const BUY_NOW_LABELS = {
    VENDOR_KEY_LABEL: 'Vendor Key',
    BRAND_KEY_LABEL: 'Brand Key',
    VENDOR_CODE: 'Vendor Code',
    BRAND_CODE: 'Brand Code',
    VENDOR_ENV_NAME: 'Buy Now ENV - Vendors',
    BRAND_ENV_NAME: 'Buy Now ENV - Brands',
    VENDOR_CODE_KEY: 'VendorCode',
    BRAND_CODE_KEY: 'BrandCode',
    VENDOR_KEY: 'VendorKey',
    BRAND_KEY: 'BrandKey',
}

export const API_LEVEL = {
    VENDOR: 'vendor',
    BRAND: 'brand'
}